import { localize } from "@vee-validate/i18n";
import { configure } from "vee-validate";

export const maxLength = (value: string, [limit]) => {
    // The field is empty so it should pass
    if (!value || !value.length) {
        return true;
    }

    if (value.length > limit) {
        return `This field must be at less ${limit} characters`;
    }

    return true;
};

export const phone = (value: string) => {

    // const pattern = /^[\d+\-\s\(\)]{8,20}$/
    const pattern = /^[0-9]{9,15}$/;
    return pattern.test(value) || "Invalid phone number";
};
export const postalCode = (value: string) => {

    // const pattern = /^[\d+\-\s\(\)]{8,20}$/
    const pattern = /^[0-9]{3,8}$/;
    return pattern.test(value) || "Invalid postal code";
};
export const minLength = (value: string, [limit]) => {
    // The field is empty so it should pass
    if (!value || !value.length) {
        return true;
    }

    if (value.length < limit) {
        return `This field must be at least ${limit} characters`;
    }

    return true;
};

export const confirmPassword = (value: string, [target], ctx) => {
    if (value === ctx.form[target]) {
        return true;
    }

    return 'Passwords must match';
};


export const handleValidationMessages = () => {
    configure({
        // Generates an English message locale generator
        generateMessage: localize("en", {
            messages: {
                required: `The {field} is required`,
                min: `Min length for {field} is {params}`,
            },
        }),
    });
}